import store from './../store'
import router from '@/router'


/**
 * 存储url数据
 * @fieldName 存储字段名
 * @paramKey 匹配字段key值
*/
export const saveUrlData =  async (fieldName,paramKey,data) => {
  store.commit("setUrlData",{
    data:JSON.stringify(data),
    pageKey:fieldName,
    paramKey:paramKey
  })
}

/**
/**
 * 存储url数据
 * @fieldName 存储字段名
 * @paramKey 匹配字段key值
 * @data 存储数据
*/
export const getPageUrlData = (fieldName,paramKey) => {
  let pageParam = {}
  if(paramKey){
    let getData = store.state.urlData[fieldName]||{};
    if(getData.paramKey&&getData.paramKey == paramKey){
      pageParam = JSON.parse(getData?.data||"{}");
      localStorage.setItem('toOrderFoodData','');
    }else{
      // 用于解析从orderFood.html?storeId=249&lang=en传来的参数
      let getData = localStorage.getItem('toOrderFoodData');
      if(getData){
        getData = JSON.parse(getData)
        if(getData.paramKey==paramKey){
          pageParam = getData;
        }else{
          localStorage.setItem('toOrderFoodData','');
        }
      }
    }
  }
  return pageParam;
}

/**
/**
 * 页面路由跳转
 * @path 路由路径
 * @fieldName 页面带参存储字段名
 * @data 页面需要带的参数
 * @queryData 需要拼接在url query 上面的参数
*/
export const routerPage = (path,fieldName,data={},queryData={},isReplace=false) => {
  if(!path||!fieldName){
    return;
  }



  let paramKey =fieldName+ new Date().getTime();//用于路由取餐
  saveUrlData(fieldName,paramKey,data);
  console.log(`=================`,path,JSON.stringify(data))
    // 跳转到v2新项目
   if (path.includes("/orderFood/")) {
    let baseURL = "";
    var href = window.location.href.split("/");
    baseURL = href[0] + "//";
    for (var i = 1; i < href.length; i++) {
      baseURL += href[i];
      if (href[i]) {
        break;
      }
    }
    console.log(baseURL,data);

    let positionInfo = data.positionInfo || {}
    // /v2/menu 会跳转v1 ? 不知道原理，先用/v2/?xxx
    // businessType 1：外卖；2：自取
    let sendType = data.businessType
    if(data?.sendType){
      sendType = data?.sendType
    }
    // 兜底
    if(!sendType){
      sendType = data.storeId ? 2 : 1
    }
    let url = baseURL + "/v2" + "/" + "?storeId=" + (data.storeId || '') + "&sendType=" + (sendType)
    if(data.reference){
      url += "&reference=" + data.reference
    }
    if(data.coupon){
      url += "&voucherId=" + data.coupon.voucherId
      // 优惠券数据
      localStorage.setItem('phdV1CouponToV2',JSON.stringify(data.coupon))
    }
    // 将 positionInfo 对象以键值对形式拼接到 URL 上
    if (Object.keys(positionInfo).length > 0) {
      Object.keys(positionInfo).forEach(key => {
        if (positionInfo[key] !== undefined && positionInfo[key] !== null) {
          url += `&${key}=${encodeURIComponent(positionInfo[key])}`
        }
      })
    }
     // /v2/?storeId=&sendType=1&cityName=Hong+Kong&address=旺角&latitude=22.319387939767136&longitude=114.16916986632168&_index=TVRrMU5qYzRNamt3
     // /v2/?storeId=1654&sendType=2&_index=TVRrMU5qYzRNamt3
    window.location.href = url
    return;
  }

  if(isReplace){
    router.replace({
      path:path,
      query:{
        paramKey,
        ...queryData
      }
    });
  }else{
    router.push({
      path:path,
      query:{
        paramKey,
        ...queryData
      }
    });
  }
 

}



